// Generated before start, test and build from shared/legal/privacy-policy.json.
module.exports = require('../generated/privacyCompliance.generated');
